/*
 * Logo de BifeAI: los archivos están en /brand de cada app (public/brand).
 * En modo oscuro se muestran en blanco (ver .bf-brand-img en globals.css).
 */

/** Solo el bife (isotipo): barra lateral cerrada y lugares chicos. */
export function BrandMark({ className = 'bf-brand-mark' }: { className?: string }) {
  return <img className={`${className} bf-brand-img`} src="/brand/bifeai-iso.svg" alt="BifeAI" />;
}

/** Logo horizontal: el bife al lado de "bife AI". */
export function Brand({ suffix }: { suffix?: string }) {
  return (
    <span className="bf-brand">
      <img className="bf-brand-logo bf-brand-img" src="/brand/bifeai-logo.svg" alt="BifeAI" width={1176} height={272} />
      {suffix && <small className="bf-brand-suffix">{suffix}</small>}
    </span>
  );
}

/** Logo apilado: el bife arriba de "bife AI". Para los paneles de acceso, donde hay lugar. */
export function BrandStacked({ className = 'bf-brand-stacked' }: { className?: string }) {
  return <img className={`${className} bf-brand-img`} src="/brand/bifeai-logo-apilado.svg" alt="BifeAI" width={832} height={780} />;
}

/** Ilustración de líneas del panel de acceso: un bife con su veteado. Decorativa. */
export function CutsIllustration({ className = 'bf-auth-cuts' }: { className?: string }) {
  return (
    <svg className={className} viewBox="0 0 360 300" fill="none" aria-hidden>
      <path
        d="M58 104c22-46 84-74 148-62 70 13 118 64 114 128-3 57-38 87-77 109-32 18-46 44-86 51-60 10-120-30-130-91-7-38 4-73 31-135Z"
        stroke="currentColor"
        strokeWidth="3"
      />
      <path
        d="M78 112c18-34 66-56 118-47 56 10 94 51 91 101-2 44-30 68-61 85-26 15-37 36-69 41-48 8-96-24-104-73-5-30 3-58 25-107Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeDasharray="2 7"
        strokeLinecap="round"
      />
      <path d="M186 70v112M130 182h112" stroke="currentColor" strokeWidth="9" strokeLinecap="round" />
      <path
        d="M104 150c14 6 22 18 20 32M248 120c-10 12-12 26-6 40M210 220c-14-4-26 0-36 10M120 222c10-8 24-10 36-6M262 196c-12 2-22 10-26 22"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
    </svg>
  );
}
